module.exports = __webpack_public_path__ + "img/user2.4ebe97be.jpg";